// extracted by mini-css-extract-plugin
export default {"toggle":"userMenu_toggle__85t0x"};